module.exports = __webpack_public_path__ + "static/media/yum logo.1d941952.png";


//////////////////
// WEBPACK FOOTER
// ./src/mockAPI/images/yum logo.png
// module id = 275
// module chunks = 0